(() => {
    Array.from(document.querySelectorAll('.rich-text h2')).forEach(h2 => {
        h2.classList.add('headline-2');
    });

    Array.from(document.querySelectorAll('.rich-text h3')).forEach(h3 => {
        h3.classList.add('headline-3');
    });

    Array.from(document.querySelectorAll('.rich-text h4')).forEach(h4 => {
        h4.classList.add('headline-4');
    });
})();
